import axios from '@axios'
import { loadStripe } from '@stripe/stripe-js'

// Every card form loads Stripe through here (RM-313). The publishable key comes
// from the server that will process the card, so the two are always in the
// same Stripe mode. The page used to choose the key from its own hostname, and
// on www.reserverm.com it chose the TEST key against the live server.
let stripePromise = null

export function loadRmStripe() {
  if (!stripePromise) {
    stripePromise = axios.get('/checkout/stripe-publishable-key')
      .then(res => loadStripe(res.data.publishableKey))
      .catch(error => {
        // Let the next card form try again instead of caching the failure.
        stripePromise = null
        throw error
      })
  }

  return stripePromise
}
